import { COLORS, Image, ImageEntity, SIZES, Typography } from '@fupa/fupa-uikit';
import React from 'react';
import styled from 'styled-components';
import getInitials from 'app/helpers/getInitials';
const IMAGE_SIZE = 36;
const RequestDetails = styled.div.withConfig({
  componentId: "sc-s7v0vu-0"
})(["display:flex;align-items:center;column-gap:0.5rem;margin-bottom:1.5rem;"]);
const RequestDetailsTextWrapper = styled.div.withConfig({
  componentId: "sc-s7v0vu-1"
})(["display:flex;flex-direction:column;"]);
const Initials = styled.div.withConfig({
  componentId: "sc-s7v0vu-2"
})(["display:flex;justify-content:center;align-items:center;width:", ";height:", ";border-radius:50%;background-color:", ";border:1px solid ", ";"], SIZES[IMAGE_SIZE], SIZES[IMAGE_SIZE], COLORS.lighterGrey, COLORS.lightGrey);
const AvatarWithInitials = _ref => {
  let {
    authorName
  } = _ref;
  const initials = getInitials(authorName);
  return /*#__PURE__*/React.createElement(Initials, {
    "data-sentry-element": "Initials",
    "data-sentry-component": "AvatarWithInitials",
    "data-sentry-source-file": "MarketplaceRequestSummary.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    component: 'span',
    variant: 'subheading',
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "MarketplaceRequestSummary.tsx"
  }, initials));
};
const MarketplaceRequestSummary = _ref2 => {
  let {
    authorName,
    club,
    title
  } = _ref2;
  let requestHeading = authorName;
  if (club !== null && club !== void 0 && club.name) {
    requestHeading += ' ' + " \u2013 ".concat(club.name);
  }
  const requestImage = club !== null && club !== void 0 && club.image ? /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Emblem,
    src: club.image,
    width: 36,
    height: 36,
    fit: true
  }) : /*#__PURE__*/React.createElement(AvatarWithInitials, {
    authorName: authorName
  });
  return /*#__PURE__*/React.createElement(RequestDetails, {
    "data-sentry-element": "RequestDetails",
    "data-sentry-component": "MarketplaceRequestSummary",
    "data-sentry-source-file": "MarketplaceRequestSummary.tsx"
  }, requestImage, /*#__PURE__*/React.createElement(RequestDetailsTextWrapper, {
    "data-sentry-element": "RequestDetailsTextWrapper",
    "data-sentry-source-file": "MarketplaceRequestSummary.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: 'body1',
    component: 'span',
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "MarketplaceRequestSummary.tsx"
  }, requestHeading), /*#__PURE__*/React.createElement(Typography, {
    variant: 'caption1',
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "MarketplaceRequestSummary.tsx"
  }, title)));
};
export default MarketplaceRequestSummary;